import React from "react"
import { BarLoader } from "react-spinners"
import styled from "styled-components"

const LoadingStyle = styled.div.attrs((props) => ({}))`
  z-index: 30;
  margin-left: auto;
  margin-right: auto;
  position: static;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 100%;

  em {
    display: block;
    font-style: normal;
    margin-bottom: 0.5em;
  }
`

const Loader = (props) => (
  <LoadingStyle className="loader" {...props}>
    {props.label ? <em>{props.label}&hellip;</em> : null}
    <BarLoader
      color={props.color || "#dddddd"}
      loading={true}
      width={props.width || 220}
      height={2}
    />
  </LoadingStyle>
)
export default Loader
